import { URLParams } from '../types'

export const parseURLParams = (): URLParams => {
  const urlParams = new URLSearchParams(window.location.search)
  
  return {
    code: urlParams.get('code') || undefined,
    token: urlParams.get('token') || undefined,
    ref: urlParams.get('ref') || undefined,
  }
}

export const isAffiliateFlow = (params: URLParams): boolean => {
  return params.ref !== undefined
}